import React, { useState, useContext, useEffect } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Input } from '../Common/Input';
import { Button } from '../Common/Button';
import EventEmitter from 'eventemitter3';
import { ContentPanel, Footer, Fullscreen, Section } from '../Common/Modal/Fullscreen';
import { Header, LogoPanel, Text } from '../Common';
import {
  FUNNEL,
  POWER_MODE,
} from '../../interfaces/ProductService.interface';
import { useIntl } from 'react-intl';
import { ShopSettingsContext } from '../../FootprintTech/AppController';
import log, { LogMode } from '../../services/LogService';
import { colors } from '../../theme';
import {version} from '../../../../package.json';
import Events from './Events';

// Define CSS variables
const Variables = {
  polly: '#e0ecf8',
  almond: '#fdf5ec'
};

interface EmailFormProps {
  emitter: EventEmitter;
  funnel: FUNNEL;
}

// const Text = styled.div`
//   font: 700 3vh/1.36 Inter, sans-serif;
//   margin-bottom: 25px;
// `;

const Blank = styled.div`
  margin-top:40px;
`;

const customCss = `

.fpt-modal {
  position: relative;
  overflow: auto;
}

.disclaimer {
  display: block;
}

`;

const EmailForm: React.FunctionComponent<EmailFormProps> = (props) => {
  const { emitter } = props;
  const intl = useIntl();
  const shopSettings = useContext(ShopSettingsContext);
  const [ continueEnabled, setContinueEnabled ] = useState(false);
  const [ isEmailValid, setIsEmailValid ] = useState(true);
  const [ email, setEmail ] = useState('');
  const minLength = 6;
  const maxLength = 256; // see https://errata.rfc-editor.org/search/?rfc_number=3696
  const placeholder = intl.formatMessage({
          id: 'drv.email-form.input.placeholder',
          defaultMessage: 'Confirm Password',
          description: 'placeholder text',
        }); // "email address";
  let userInput = '';

  const onChange = ev => {
    ev.nativeEvent.stopImmediatePropagation();
    userInput = ev.target.value;
    const emailIsValid = !!validateEmail(userInput);
    if (emailIsValid) {
      setEmail(userInput);
    }
    setContinueEnabled(emailIsValid);
    // log.info(`Email changed: ${userInput}`);
  };

  // Source - https://stackoverflow.com/a/46181
  // Posted by John Rutherford, modified by community. See post 'Timeline' for change history
  // Retrieved 2026-10-21, License - CC BY-SA 4.0
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
};

  const handleContinue = ev => {
    log.info('continue clicked', email);
    const emailIsValid = !!validateEmail(email);
    setIsEmailValid(emailIsValid);

    if (isEmailValid) {
      return emitter.emit(Events.onEmailSubmit, email);
    }

    // if (currentOptions === speedOptions) {
    //   setContinueEnabled(false);
    //   setCurrentOptions(measureOptions);
    //   emitter.emit(Events.onSpeedOptionConfirm, selectedSpeedOption);
    // } else if(powerMode === POWER_MODE.NONE) {
    //   setCurrentOptions(measureOptions);
    //   emitter.emit(Events.onSpeedOptionConfirm, selectedSpeedOption);
    // } else {
    //   emitter.emit(Events.onMeasureOptionConfirm, selectedMeasureOption);
    // }
  }

  useEffect(() => {

    // sessionService.updateExitCode('PDP', 'input-selection.displayed');
    // emitter.addListener(Events.onMeasureOptionSelect, handleMeasureOptionSelect);
    // emitter.addListener(Events.onSpeedOptionSelect, handleSpeedOptionSelect);
    // emitter.addListener(Events.onContinuePress, handleContinue);
    //
    // log.info(`Power mode: ${powerMode}`);
    //
    // if (powerMode === POWER_MODE.MANDATORY) {
    //   setSelectedSpeedOption(SPEED_OPTION.FAST_TRACK);
    //   emitter.emit(Events.onSpeedOptionConfirm, SPEED_OPTION.FAST_TRACK);
    // }

  }, []);

  return (
    <Fullscreen
      emitter={emitter}
      isClosable={false}
      style={{
        backgroundImage: `linear-gradient(to bottom, ${Variables.polly}, ${Variables.almond})`,
      }}
    >
      <LogoPanel />
      <ContentPanel>
        <Header className="fpt--bottom-margin">
          <FormattedMessage id="drv.email-form.title" />
        </Header>
        <Blank />
        <Input
          placeholder={placeholder}
          type="email"
          maxLength={maxLength}
          minLength={minLength}
          onChange={onChange}
        />
        <Text style={{ display: isEmailValid ? 'none' : 'block' }}>Invalid Email Address</Text>
      </ContentPanel>
      <Footer className="disclaimer">
      { log.mode === LogMode.VERBOSE &&
        <Section>Driver version: {version}</Section>
      }
        <Section>
          <Button
            disabled={ continueEnabled ? false : true }
            onClick={handleContinue} type="button"
            className="wide-primary">
            <FormattedMessage id="common.submit" />
          </Button>
        </Section>
      </Footer>
    </Fullscreen>
  )
};

export default EmailForm;
